export function flexible(window: Window, document: Document, baseFontSize = 16, designWidth = 375, destroySecond?: number) {
  const docEl = document.documentElement;
  const dpr = window.devicePixelRatio || 1;

  // adjust body font size
  // function setBodyFontSize() {
  //   if (document.body) {
  //     document.body.style.fontSize = 12 * 2 + 'px';
  //   } else {
  //     document.addEventListener('DOMContentLoaded', setBodyFontSize);
  //   }
  // }
  // setBodyFontSize();

  function setRemUnit() {
    const rem = (docEl.clientWidth / designWidth) * baseFontSize;
    docEl.style.fontSize = rem + 'px';
  }

  setTimeout(() => {
    setRemUnit();
  }, 100);

  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit);
  if (destroySecond) {
    setTimeout(() => {
      window.removeEventListener('resize', setRemUnit);
    }, destroySecond * 1000);
  }
  const hasSetByPageshow = false;
  window.addEventListener('pageshow', function (e) {
    if (!hasSetByPageshow) {
      if (e.persisted) {
        // hasSetByPageshow = true;  // 只执行一次
        setRemUnit();
      }
    }
  });

  // detect 0.5px supports
  if (dpr >= 2) {
    const fakeBody = document.createElement('body');
    const testElement = document.createElement('div');
    testElement.style.border = '.5px solid transparent';
    fakeBody.appendChild(testElement);
    docEl.appendChild(fakeBody);
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines');
    }
    docEl.removeChild(fakeBody);
  }
}
